import React from 'react';
import Container from '../../../components/container';
import Statistics from './components/statistics';

const Dashboard = () => (
  <Container pageTitle="Dashboard">
    <Statistics />
  </Container>
);
export default Dashboard;
